export default {
  DOCUMENTATION: {
    CAN_EDIT_DOCUMENT: false,
    CAN_ADD_GROUP: false,
    CAN_ADD_DOCUMENT: false,
    CAN_DELETE_GROUP: false
  },
  USER_MANAGEMENT: {
    CAN_ADD: false,
    CAN_EDIT: false,
    CAN_REMOVE: false,
    CAN_DISABLE: false,
    CAN_CHANGE_PASSWORD: false,
    CAN_VIEW_OTHERS: false
  },
  ERROR_STATISTICS: {

  },
  CUSTOMER_MANAGEMENT: {
    CAN_DELETE_CUSTOMERS: false,
    CAN_ADD_CUSTOMERS: false,
    CAN_VIEW_OTHER_CUSTOMERS: false,
    CAN_VIEW_CUSTOMER_INFORMATION: false,
    CAN_VIEW_LICENCES: false,
    CAN_VIEW_REMOTE_CONNECTIONS: false,
    CAN_VIEW_CUSTOMERS_USERS: false,
    CAN_VIEW_SCHEMA_COMPARES: false,
    CAN_VIEW_HARDWARE_COMPANY: false,
    CAN_VIEW_USER_COUNTS: false,
    LICENCE_MANAGEMENT: {
      CAN_ADD_LICENCES: false,
      CAN_REVOKE_LICENCES: false
    },
    REMOTE_CONNECTIONS: {
      CAN_ADD_REMOTE_CONNECTIONS: false,
      CAN_MAKE_CONNECTIONS: false,
      CAN_COPY_DETAILS: false
    },
    CUSTOMER_USERS: {
      CAN_REQUEST_USER_LIST: false,
      CAN_UPDATE_CUSTOMERS: false,
      CAN_DISABLE_USERS: false
    },
    CUSTOMER_INFORMATION: {
      CAN_EDIT_INFORMATION: false
    }
  },
  VERSION_MANAGEMENT: {
    CAN_ADD_VERSIONS: false,
    CAN_DELETE_VERSIONS: false,
  },
  NAVIGATION: {
    CAN_VIEW_ERROR_STATISTICS: false,
    CAN_VIEW_DOCUMENTATION: true,
    CAN_VIEW_USER_MANAGEMENT: false,
    CAN_VIEW_CUSTOMER_MANAGEMENT: false,
    CAN_VIEW_LICENCE_MANAGEMENT: false,
    CAN_VIEW_HARDWARE_MANAGEMENT: false,
    CAN_VIEW_VERSION_MANAGEMENT: false,
  }
}
